import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "app/store";
import { initialState } from "./professionalRegistrationSlice";

const professionalRegistrationSlice = (state: RootState) =>
  state.professionalRegistration || initialState;

export const selectBasicDetails = createSelector(
  [professionalRegistrationSlice],
  (state) => state.basicDetails
);

export const selectUniversityDetails = createSelector(
  [professionalRegistrationSlice],
  (state) => state.universityDetails
);

export const selectWorkDetails = createSelector(
  [professionalRegistrationSlice],
  (state) => state.workDetails
);

export const selectProfessionalMetadata = createSelector(
  [professionalRegistrationSlice],
  (state) => state.metadata
);
export const selectStepperActiveStep = createSelector(
  [professionalRegistrationSlice],
  (state) => state.activeStep
);

export const selectIsNextStep = createSelector(
  [professionalRegistrationSlice],
  (state) => state.isNextStep
);